import {StandardDNACodon} from 'biojs/Codons';
import * as net from 'util/Net';

export function getCodonUsage(organismId: number): JQueryPromise<{data: Record<StandardDNACodon, number>}> {
  return net.getJSON(`/1/api/organisms/${organismId}/codon-usage/`);
}
